<template>
    <div class="background" :style="backImg" :class="fullscreen">
        <!-- <div>
        </div> -->
        <el-row class="topInfo">
            <el-col type="flex" :span="18">
                <div style="display: flex; align-items: center"><img class="Logo" src="../../../assets/icon/LOGO.png" alt="" /><span class="topTit">智能生产看板系统</span></div>
            </el-col>
            <el-col type="flex" :span="6">
                <div class="time">
                    <img class="timeimg" src="../../../assets/icon/时间.png" alt="" />
                    <span style="font-size: 1.2vw; margin-left: 1vw">{{ date | formaDate }}</span>
                    <div @click="fullscreens()" v-show="full === true">
                        <img class="mouse" style="width: 1.5vw; height: 1.5vw; margin-left: 2vw" src="../../../assets/icon/全屏.png" alt="" />
                    </div>
                    <div @click="fullscreens2()" v-show="full === false">
                        <img class="mouse" style="width: 1.8vw; height: 1.8vw; margin-left: 2vw" src="../../../assets/icon/缩小.png" alt="" />
                    </div>
                </div>
            </el-col>
        </el-row>
        <div v-show="isshow" style="display: flex; font-size: 1vw; color: #fff; height: 8vh">
            <span class="textSty3">
                工厂：
                <el-select v-model="fcIdSelected" placeholder="请选择" :clearable="isclear" :disabled="ischeck" filterable @change="fcChange">
                    <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label" :value="factory.value"> </el-option>
                </el-select>
            </span>
            <span class="textSty3">
                车间：
                <el-select v-model="shopSelected" placeholder="请选择" clearable filterable @change="shopChange">
                    <el-option v-for="shop in shopList" :key="shop.value" :label="shop.label" :value="shop.value"> </el-option>
                </el-select>
            </span>
            <span class="textSty3">
                工段：
                <el-select v-model="sectionSelected" placeholder="请选择" clearable filterable @change="sectionChange">
                    <el-option v-for="section in sectionList" :key="section.value" :label="section.label" :value="section.value"> </el-option>
                </el-select>
            </span>
            <span class="textSty3">
                产线：
                <el-select v-model="lineSelected" placeholder="请选择" clearable filterable @change="lineChange">
                    <el-option v-for="line in lineList" :key="line.value" :label="line.label" :value="line.value"> </el-option>
                </el-select>
            </span>
            <!--<div class="textSty" :style="TitbgImg">
                <span>康桥工厂</span>
            </div>-->
            <!--<div class="long"></div>
            <span class="textSty3">车间：</span>
            <div style="display: flex">
                <div :class="{ textStyList: index == inde }" class="textSty2" v-for="(item, index) in workshop"
                     :key="item" @click="textStycut(index, item)">
                    {{ item.shopName }}
                </div>
            </div>-->
        </div>
        <!-- <div> -->
        <el-row :gutter="0" style="margin-top: 1vw">
            <el-col style="height: 51vh" class="moduleInfo moduleBgColor" :span="14">
                <div style="margin: 1vw 1vw 0 1vw; display: flex">
                    <el-col style="display: flex" :span="17">
                        <img class="repairbill" src="../../../assets/icon/icon-楼层平面图.png" alt="" />
                        <span class="textSty4">车间布局图</span>
                        <img style="width: 3vw; height: 1.5vh; margin: 1vw" src="../../../assets/icon/装饰.png" alt="" />
                    </el-col>
                    <el-col style="display: flex; width: 100%" :span="7">
                        <!--<img class="maintain" src="../../../assets/icon/形状1.png" alt="" />
                        <span style="color: red; align-items: center; display: flex">待维修</span>
                        <img class="maintain" style="margin-left: 2vw" src="../../../assets/icon/形状1拷贝2.png" alt="" />
                        <span style="color: #d9c950; align-items: center; display: flex">维修中</span>-->
                        <span style="color: #cccccc; align-items: center; display: flex; margin-left: 2vw">闲置中</span>
                        <span style="color: #67de37; align-items: center; display: flex; margin-left: 2vw">运行中</span>
                        <span style="color: #f35358; align-items: center; display: flex; margin-left: 2vw">故障</span>
                        <span style="color: #d9c950; align-items: center; display: flex; margin-left: 2vw">停机中</span>
                    </el-col>
                    <!-- <el-col style="display: flex" :span="7">
                    </el-col> -->
                </div>
                <el-col :span="7" class="echar">
                    <div id="echarInfo"></div>
                </el-col>
                <el-col class="section" :span="15">
                    <div style="display: flex; flex-wrap: wrap">
                        <!-- <img src="../../../assets/icon/区域SVG.svg" alt="" /> -->
                        <div v-for="(item, index) in blockNum" :key="item.devCode" :index="index" :style="getStyle(item)" class="divBor textSty5">
                            {{ item.devName }}
                        </div>
                    </div>
                </el-col>
            </el-col>
            <el-col style="height: 51vh" :span="9">
                <div style="height: 100%" class="moduleInfo moduleBgColor">
                    <div style="display: flex; align-items: center; height: 8vh">
                        <img class="repairbill2" src="../../../assets/icon/维修单.png" alt="" />
                        <span class="textSty4">实时维修单</span>
                        <img style="width: 3vw; height: 1.5vh; margin: 0 1vw 0 1vw" src="../../../assets/icon/装饰.png" alt="" />
                    </div>
                    <div class="equiinfo" style="height: 43vh">
                        <div style="display: flex; font-weight: bold; background-color: rgb(42, 102, 165); color: #fff; height: 3vw; align-items: center">
                            <span style="width: 20%; text-align: center">报修状态</span>
                            <span style="width: 20%; text-align: center">报修内容</span>
                            <span style="width: 20%; text-align: center">所属车间</span>
                            <span style="width: 20%; text-align: center">报修时间</span>
                            <span style="width: 20%; text-align: center">等待时间</span>
                        </div>
                        <div style="display: flex; height: 42.5%; border-bottom: 1px #ccc solid; width: 100%">
                            <div style="width: 20%; display: flex; justify-content: center">
                                <div style="color: #e13e43">
                                    <p style="font-size: 4vw; margin-top: 2vw; display: flex; justify-content: center">{{ tableData.length }}</p>
                                    <p style="display: flex; justify-content: center">待接单</p>
                                </div>
                            </div>
                            <el-table
                                :show-header="false"
                                :row-class-name="tableRowClassName"
                                :cell-style="{ width: '40px' }"
                                :data="tableData"
                                style="width: 80%; overflow: auto; font-size: 0.8vw; overflow: auto"
                                :header-cell-style="{ background: '#2a66a5', color: '#fff' }"
                                @current-change="andonCreateCurrentChange"
                            >
                                <!-- <el-table-column style="color: red" height="200" prop="state" label="报修状态" :show-overflow-tooltip="true">
                                    <template>
                                        <div style="display: flex; position: absolute; top: 0.5%; left: 25%; height: 100%">
                                            <div style="color: #e13e43; height: 7vw; position: fixed">
                                                <p style="font-size: 4vw; margin-top: 2vw">5</p>
                                                <p style="margin-top: 2vw">待接单</p>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column> -->
                                <el-table-column align="center" label="报修内容" :show-overflow-tooltip="true">
                                    <template scope="scope">
                                        <div style="width: 5vw">
                                            {{ scope.row.andonProbDesc }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" label="所属车间" :show-overflow-tooltip="true">
                                    <template scope="scope">
                                        <div style="width: 5vw">
                                            {{ scope.row.shopName }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" label="报修时间" show-overflow-tooltip>
                                    <template scope="scope">
                                        <span style="width: 5vw">
                                            {{ scope.row.createTime }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="andonRespTime" align="center" label="等待时间" :show-overflow-tooltip="true">
                                    <template slot-scope="scope">
                                        <div style="width: 2vw">
                                            <!--                                    <countdown></countdown>-->
                                            <!--<div class="countdown" style="font-size: 0.8vw; line-height: 9px"></div>
                                 <van-count-down use-slot ref="countDown" :time="time * 1000" @change="onTimeChange">
                                        <van-progress :show-pivot="false" color="#f2826a" :percentage="percentage" />
                                 </van-count-down>-->
                                            <van-count-down :time="scope.row.countDown" />
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div style="display: flex; height: 42.5%">
                            <div style="width: 20%; display: flex; justify-content: center">
                                <div style="color: #ffbf44">
                                    <p style="font-size: 4vw; margin-top: 2vw; display: flex; justify-content: center">{{ tableWaitData.length }}</p>
                                    <p style="display: flex; justify-content: center">待完成</p>
                                </div>
                            </div>
                            <el-table
                                :show-header="false"
                                :row-class-name="tableRowClassName"
                                :cell-style="{ width: '40px' }"
                                :data="tableWaitData"
                                style="width: 80%; overflow: auto; font-size: 0.8vw; overflow: auto"
                                :header-cell-style="{ background: '#2a66a5', color: '#fff' }"
                                @current-change="andonCreateCurrentChange"
                            >
                                <!-- <el-table-column style="color: red" prop="state" align="center" label="报修状态" :show-overflow-tooltip="true">
                                <template>
                                    <div style="display: flex; position: absolute; top: 0.5%; left: 25%; height: 100%">
                                        <div style="color: #ffbf44; height: 7vw; position: fixed">
                                            <p style="font-size: 4vw; margin-top: 2vw">5</p>
                                            <p style="margin-top: 2vw">待完成</p>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column> -->
                                <el-table-column align="center" label="报修内容" :show-overflow-tooltip="true">
                                    <template scope="scope">
                                        <div style="width: 5vw">
                                            {{ scope.row.andonProbDesc }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="所属车间" :show-overflow-tooltip="true">
                                    <template scope="scope">
                                        <div style="width: 5vw">
                                            {{ scope.row.shopName }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" label="报修时间" :show-overflow-tooltip="true">
                                    <template scope="scope">
                                        <span style="width: 5vw">
                                            {{ scope.row.createTime }}
                                        </span>
                                    </template></el-table-column
                                >
                                <el-table-column prop="andonRespTime" align="center" label="等待时间" :show-overflow-tooltip="true">
                                    <template slot-scope="scope">
                                        <div style="width: 2vw">
                                            <!--                                    <countdown></countdown>-->
                                            <!--<div class="countdown" style="font-size: 0.8vw; line-height: 9px"></div>
                                 <van-count-down use-slot ref="countDown" :time="time * 1000" @change="onTimeChange">
                                        <van-progress :show-pivot="false" color="#f2826a" :percentage="percentage" />
                                 </van-count-down>-->
                                            <van-count-down :time="scope.row.countDown" />
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="0">
            <el-col :span="14" style="margin-left: 1vw">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div style="display: flex; flex-wrap: wrap" class="dutyNum" @click="userManu">
                            <div style="display: flex; align-items: center; height: 8vh; width: 100%">
                                <img class="repairbill3" src="../../../assets/icon/人员lxx.png" alt="" />
                                <span class="textSty4">当班人数</span>
                                <img style="width: 3vw; height: 1.5vh; margin: 0 1vw 0 1vw" src="../../../assets/icon/装饰.png" alt="" />
                            </div>
                            <div style="display: flex; color: #fff; width: 100%" class="Sty1">
                                <div style="flex: 1; text-align: center">
                                    <p>维修总人数</p>
                                    <h3 class="Sty1 styColor1">{{ searchData.total }}</h3>
                                </div>
                                <div style="flex: 1; text-align: center">
                                    <p>接单人数</p>
                                    <h3 class="Sty1 styColor1">{{ searchData.onJob }}</h3>
                                </div>
                                <div style="flex: 1; text-align: center">
                                    <p>接单数</p>
                                    <h3 class="Sty1 styColor1">{{ searchData.takingAmount }}</h3>
                                </div>
                            </div>
                            <div style="display: flex; color: #fff; margin-top: 2vw; width: 100%" class="Sty1">
                                <div style="flex: 1; text-align: center">
                                    <p>当月总共单数</p>
                                    <p>(当月)</p>
                                    <h3 class="Sty1 styColor1">{{ searchData.averageTaking }}</h3>
                                </div>
                                <div style="flex: 1; text-align: center">
                                    <p>平均故障响应时间</p>
                                    <p>(当月)</p>
                                    <h3 class="Sty1 styColor1">{{ searchData.averageResponseTime }}</h3>
                                </div>
                                <div style="flex: 1; text-align: center">
                                    <p>平均故障修复时间</p>
                                    <p>(当月)</p>
                                    <h3 class="Sty1 styColor1">{{ searchData.averageRepairTime }}</h3>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 2vw">
                        <div class="dutyNum">
                            <div style="display: flex; align-items: center; height: 8vh">
                                <img class="repairbill3" src="../../../assets/icon/对比.png" alt="" />
                                <span class="textSty4">车间参数对比</span>
                                <img style="width: 3vw; height: 1.5vh; margin: 0 1vw 0 1vw" src="../../../assets/icon/装饰.png" alt="" />
                            </div>
                            <div style="height: 23vh">
                                <div id="ecahrbar"></div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="9">
                <div style="margin-left: 1vw; height: 32vh">
                    <el-row class="manInfo" style="height: 60%">
                        <el-col :span="24" style="height: 100%">
                            <div style="display: flex; align-items: center; height: 35%">
                                <img class="repairbill4" src="../../../assets/icon/统计.png" alt="" />
                                <span class="textSty4">统计维修</span>
                                <img style="width: 3vw; height: 1.5vh; margin: 0 1vw 0 1vw" src="../../../assets/icon/装饰.png" alt="" />
                            </div>
                            <div style="display: flex; color: #fff; height: 65%; display: flex; align-items: center" class="Sty1">
                                <div style="flex: 1; text-align: center">
                                    <p>今日报修</p>
                                    <h3 class="Sty1 styColor1 stymar">{{ searchData.trAmount }}</h3>
                                </div>
                                <div style="flex: 1; text-align: center">
                                    <p>完成数</p>
                                    <h3 class="Sty1 styColor1 stymar">{{ searchData.trCompleteAmount }}</h3>
                                </div>
                                <div style="flex: 1; text-align: center">
                                    <p>未完成数</p>
                                    <h3 class="Sty1 styColor1 stymar">{{ searchData.trUnCompleteAmount }}</h3>
                                </div>
                                <div style="flex: 1; text-align: center">
                                    <p>完成率</p>
                                    <el-progress class="Sty1" stroke-width="4" color="#35ebcf" width="35" height="35" type="circle" :percentage="searchData.todayRate"></el-progress>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row class="manInfo" style="margin-top: 1vw; height: 35%; display: flex; align-items: center">
                        <el-col :span="24">
                            <div style="display: flex; color: #fff" class="Sty1">
                                <div style="flex: 1; text-align: center">
                                    <p>本月报修</p>
                                    <h3 class="Sty1 styColor1 stymar">{{ searchData.mrAmount }}</h3>
                                </div>
                                <div style="flex: 1; text-align: center">
                                    <p>完成数</p>
                                    <h3 class="Sty1 styColor1 stymar">{{ searchData.mrCompleteAmount }}</h3>
                                </div>
                                <div style="flex: 1; text-align: center">
                                    <p>未完成数</p>
                                    <h3 class="Sty1 styColor1 stymar">{{ searchData.mrUnCompleteAmount }}</h3>
                                </div>
                                <div style="flex: 1; text-align: center">
                                    <p>完成率</p>
                                    <el-progress class="Sty1" stroke-width="4" color="#3be837" width="35" height="35" type="circle" :percentage="searchData.monthRate"></el-progress>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-row>
        <!-- </div> -->
    </div>
</template>

<script>
import * as echarts from 'echarts'
import countdown from '@/components/public/countdown.vue'
//创建一个函数来增加月日时小于10在前面加0
var padaDate = function (value) {
  return value < 10 ? '0' + value : value
}
import moment from 'moment'

export default {
  components: {
    countdown
  },
  data () {
    return {
      isshow: true,
      workshop: [],
      blockNum: ['区块编号', 'A001', '区块编号', 'TB-8H61', '区块编号', 'BU-82Y1', 'AJ-621U', 'OQ-127H12', 'HR-12751H', '区块编号', '区块编号', '区块编号', '区块编号', 'A003', '区块编号', 'AQ-1275H', '区块编号', 'A003', '区块编号', 'AQ-1275H'],
      inde: 0,  //样式改变
      echarInfo: [],
      bgColor: 'bgColor3',
      fullscreen: '',
      full: true,
      tableData: [],
      tableWaitData: [],
      percentage: 100, // 进度百分比
      time: 1800, // 单位秒
      date: new Date(), //实时时间
      TitbgImg: {
        backgroundImage: 'url(' + require('../../../assets/icon/Titbgimg.png') + ')',
        backgroundRepeat: 'no-repeat'
      },
      backImg: {
        backgroundImage: 'url(' + require('../../../assets/icon/background.png') + ')',
        backgroundRepeat: 'no-repeat'
      },
      userInfo: {},
      role: {},
      ischeck: true,
      isclear: false,
      isChange: true,
      fcCode: '',
      shopCode: '',
      shopItem: {},
      searchParams: {
        param: {},
        pageSize: 10,
        page: 1,
        pageCount: 0
      },
      searchData: {
        averageArriveTime: '',//平均到达现场时长
        averageRepairTime: '',//平均故障修复时长
        averageResponseTime: '',//平均故障响应时长
        averageTaking: '',//人均工单数
        devAbnormal: '',//设备异常数
        devNormal: '',//设备正常数
        mrAmount: '',//本月报修数
        mrCompleteAmount: '',//本月完成数
        mrUnCompleteAmount: '',//本月未完成数
        onJob: '',//在岗人数
        shopDevList: [],//车间信息
        takingAmount: '',//维修忙碌人数
        total: '',//总人数
        trAmount: '',//今日报修数
        trCompleteAmount: '',//今日完成数
        trUnCompleteAmount: '',//今日未完成数
        todayRate: '',//维修统计今日完成率
        monthRate: ''//维修统计本月完成率
      },
      shopCode: '',
      intervalId: null,
      factoryTree: [],
      fcIdSelected: '',
      sectionSelected: '',
      shopSelected: '',
      lineSelected: ''
    }
  },
  computed: {
    factoryList: function () {
      var arr = []
      var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      if (this.factoryTree != undefined && this.factoryTree.length > 0) {
        if (this.ischeck) {
          for (var i = 0;i < this.factoryTree.length;i++) {
            for (let j = 0;j < userInfo.roles.length;j++) {
              if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                arr.push({
                  label: this.factoryTree[i].deptName,
                  id: this.factoryTree[i].deptID,
                  value: JSON.stringify(this.factoryTree[i]),
                  deptLevel: this.factoryTree[i].deptLevel,
                  parent: 0
                })
              }
            }
          }
        } else {
          for (var i = 0;i < this.factoryTree.length;i++) {
            arr.push({
              label: this.factoryTree[i].deptName,
              id: this.factoryTree[i].deptID,
              value: JSON.stringify(this.factoryTree[i]),
              deptLevel: this.factoryTree[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    },
    shopList: function () {
      var arr = []
      if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
        var factory = JSON.parse(this.fcIdSelected)
        var shops = factory.child
        for (var i = 0;i < shops.length;i++) {
          if (shops[i].hasOwnProperty('deptCode')) {
            arr.push({
              label: shops[i].deptName,
              id: shops[i].deptID,
              value: JSON.stringify(shops[i]),
              deptLevel: shops[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    },
    sectionList: function () {
      var arr = []
      if (this.shopSelected != undefined && this.shopSelected.length > 0) {
        var shop = JSON.parse(this.shopSelected)
        var vsms = shop.child
        for (var i = 0;i < vsms.length;i++) {
          if (vsms[i].hasOwnProperty('deptCode')) {
            arr.push({
              label: vsms[i].deptName,
              id: vsms[i].deptID,
              value: JSON.stringify(vsms[i]),
              deptLevel: vsms[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    },
    lineList: function () {
      var arr = []
      if (this.sectionSelected != undefined && this.sectionSelected.length > 0) {
        var vsm = JSON.parse(this.sectionSelected)
        var lines = vsm.child
        for (var i = 0;i < lines.length;i++) {
          if (lines[i].hasOwnProperty('deptCode')) {
            arr.push({
              label: lines[i].deptName,
              id: lines[i].deptID,
              value: JSON.stringify(lines[i]),
              deptLevel: lines[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    }
  },
  destroyed () {
    // 在页面销毁后，清除计时器
    this.clear()
  },
  created () {
    this.dataRefreh()
  },
  mounted () {
    this.init()
    var _this = this //声明一个变量指向vue实例this,保证作用域一致
    this.timer = setInterval(function () {
      _this.date = new Date()//修改数据date
    }, 1000)
  },
  methods: {
    init () {
      // this.userInfo = sessionStorage.getItem("userInfo")
      this.userInfo = this.$store.state.userInfo
      var role = this.userInfo.roles
      for (var i = 0;i < role.length;i++) {
        //所有工厂数据
        if (role[i].factoryId == 0) {
          this.ischeck = false
          this.role = role[i]
          this.isclear = true
          break
        } else {
          if (this.userInfo.factoryId == role[i].factoryId) {
            this.role = role[i]
          }
        }
      }
      this.getData()
    },
    // 定时刷新数据函数
    dataRefreh () {
      // 计时器正在进行中，退出函数
      if (this.intervalId != null) {
        return
      }
      // 计时器为空，操作
      this.intervalId = setInterval(() => {
        console.log('刷新' + new Date())
        this.getAllData() //加载数据函数
      }, 5000)
    },
    // 停止定时器
    clear () {
      clearInterval(this.intervalId) //清除计时器
      this.intervalId = null //设置为null
    },
    /*fcChange() {
        this.isChange = false
        if (this.fcCode != undefined && this.fcCode != '') {
            this.getWorkShop()
        } else {
            this.clearAll()
        }
    },*/
    userManu () {
      var array = {}
      if (this.fcCode != undefined && this.fcCode != '') {
        array['fcCode'] = this.fcCode
      }
      if (this.shopItem.shopCode != undefined && this.shopItem.shopCode != '') {
        if (this.shopItem.shopCode == '0') {
          array['shopCode'] = ''
        } else {
          array['shopCode'] = this.shopItem.shopCode
        }
      }
      this.$router.push({
        name: 'userSpectaculars',
        params: {
          userManu: array
        }
      })
    },
    andonCreateCurrentChange (row) {
      var array = JSON.parse(JSON.stringify(row))
      if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
        array['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
      }
      if (this.shopSelected != undefined && this.shopSelected != '') {
        array['shopCode'] = JSON.parse(this.shopSelected).deptCode
      }
      if (this.sectionSelected != undefined && this.sectionSelected != '') {
        array['sectionCode'] = JSON.parse(this.sectionSelected).deptCode
      }
      if (this.lineSelected != undefined && this.lineSelected != '') {
        array['lineCode'] = JSON.parse(this.lineSelected).deptCode
      }
      this.$router.push({
        name: 'andonOrderList',
        params: {
          andonCreateManu: array
        }
      })
    },
    andonWaitCurrentChange (row) {
      var array = JSON.parse(JSON.stringify(row))
      if (this.fcCode != undefined && this.fcCode != '') {
        array['fcCode'] = this.fcCode
      }
      if (this.shopItem.shopCode != undefined && this.shopItem.shopCode != '') {
        if (this.shopItem.shopCode == '0') {
          array['shopCode'] = ''
        } else {
          array['shopCode'] = this.shopItem.shopCode
        }
      }
      this.$router.push({
        name: 'andonOrderList',
        params: {
          andonWaitManu: array
        }
      })
    },
    clearAll () {
      this.searchData = {}
      this.shopItem = {}
      this.blockNum = []
      this.workshop = []
      this.echarInfo = [
        {
          value: 0,
          name: '异常'
        },
        {
          value: 0,
          name: '正常'
        }
      ]
      this.$nextTick(() => {
        this.echarts(this.echarInfo)
      })
      var array = [['product', '正常', '异常']]
      this.$nextTick(() => {
        this.ecahrbar(array)
      })
    },
    getStyle (item) {
      if (item.devRunStatus.code != undefined && item.devRunStatus.code != '') {
        if (item.devRunStatus.code == 'in_run') {
          return {
            'background-color': '#67de37'
          }
        } else if (item.devRunStatus.code == 'in_idle') {
          return {
            'background-color': '#cccccc'
          }
        } else if (item.devRunStatus.code == 'in_fault') {
          return {
            'background-color': '#f35358'
          }
        } else if (item.devRunStatus.code == 'in_halt') {
          return {
            'background-color': '#d9c950'
          }
        }
      }
      return {}
    },
    fcChange: function () {
      this.isChange = false
      this.shopSelected = ''
      this.sectionSelected = ''
      this.lineSelected = ''
      this.getAllData()
    },
    shopChange: function () {
      this.sectionSelected = ''
      this.lineSelected = ''
      this.getAllData()
    },
    sectionChange: function () {
      this.lineSelected = ''
      this.getAllData()
    },
    lineChange: function () {
      this.getAllData()
    },
    getData () {
      var self = this
      let options = {
        method: 'GET',
        url: this.$api.departTree
      }
      this.$http.request(options).then(response => {
        this.factoryTree = response.data
        for (var i = 0;i < self.factoryTree.length;i++) {
          if (this.ischeck && this.isChange) {
            if (self.factoryTree[i].deptID == self.role.factoryId) {
              self.fcIdSelected = JSON.stringify(self.factoryTree[i])
            }
          } else if (!this.ischeck && this.isChange) {
            self.fcIdSelected = JSON.stringify(self.factoryTree[0])
          }
        }
        this.getAllData()
      })
    },
    getAllData () {
      this.getFactoryRepair()
      this.getFactoryDev()
      this.getFactoryAndon()
      this.getFactoryWaitAndon()
    },
    /*getAllFactory() {
        let options = {
            method: 'get',
            url: this.$api.getAllFactory
        }
        this.$http.request(options).then(response => {
            if (response.status == 100) {
                this.factoryList = []
                var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                var aa = response.data
                if (this.ischeck && this.isChange) {
                    for (var i = 0; i < aa.length; i++) {
                        for (let j = 0; j < userInfo.roles.length; j++) {
                            if (aa[i].factoryId == userInfo.roles[j].factoryId) {
                                this.factoryList.push(aa[i])
                                this.fcCode = this.userInfo.fcCode
                            }
                        }
                    }
                } else if(!this.ischeck && this.isChange) {
                    this.factoryList = response.data
                    this.fcCode = this.factoryList[0].fcCode
                }
                this.getWorkShop()
            }
        })
    },*/
    getWorkShop () {
      let params = {
        fcCode: this.fcCode
      }
      let options = {
        method: 'get',
        url: this.$api.getWorkShopList,
        params: params
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          if (response.data != undefined && response.data != '') {
            var aa = response.data
            this.workshop = [
              {
                shopCode: '0',
                shopId: '0',
                shopName: '全部'
              }
            ]
            for (let i = 0;i < aa.length;i++) {
              var array = {
                shopCode: '',
                shopId: '',
                shopName: ''
              }
              array.shopCode = aa[i].shopCode
              array.shopId = aa[i].shopId
              array.shopName = aa[i].shopName
              this.workshop.push(array)
            }
          } else {
            this.workshop = []
          }
        }
      })
    },
    getFactoryRepair () {
      let params = {}
      if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
        params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
      }
      if (this.shopSelected != undefined && this.shopSelected != '') {
        params['shopCode'] = JSON.parse(this.shopSelected).deptCode
      }
      if (this.sectionSelected != undefined && this.sectionSelected != '') {
        params['sectionCode'] = JSON.parse(this.sectionSelected).deptCode
      }
      if (this.lineSelected != undefined && this.lineSelected != '') {
        params['lineCode'] = JSON.parse(this.lineSelected).deptCode
      }
      let options = {
        method: 'get',
        url: this.$api.factoryRepair,
        params: params
      }
      var self = this
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          //环形图数据处理
          self.searchData = JSON.parse(JSON.stringify(response.data))
          self.searchData.trCompleteAmount == 0 && self.searchData.trAmount == 0 ?
            self.searchData.todayRate = 0 : self.searchData.todayRate =
            ((self.searchData.trCompleteAmount / self.searchData.trAmount) * 100).toFixed(2)
          self.searchData.mrCompleteAmount == 0 && self.searchData.mrAmount == 0 ?
            self.searchData.monthRate = 0 : self.searchData.monthRate =
            ((self.searchData.mrCompleteAmount / self.searchData.mrAmount) * 100).toFixed(2)
          var echarInfoArray = [
            {
              value: self.searchData.devAbnormal,
              name: '异常'
            },
            {
              value: self.searchData.devNormal,
              name: '正常'
            }
          ]
          self.echarInfo = echarInfoArray
          self.$nextTick(() => {
            self.echarts(self.echarInfo)
          })
          //柱状图数据处理
          var array = [['product', '正常', '异常']]
          for (let i = 0;i < self.searchData.shopDevList.length;i++) {
            var arr = []
            if (self.searchData.shopDevList[i].devNormal != 0 || self.searchData.shopDevList[i].devAbnormal != 0) {
              arr.push(self.searchData.shopDevList[i].shopName)
              arr.push(self.searchData.shopDevList[i].devNormal)
              arr.push(self.searchData.shopDevList[i].devAbnormal)
              array.push(arr)
            }
          }
          self.$nextTick(() => {
            self.ecahrbar(array)
          })
        } else {
          self.searchData = {}
        }
      })
    },
    getFactoryDev () {
      let params = {}
      if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
        params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
      }
      if (this.shopSelected != undefined && this.shopSelected != '') {
        params['shopCode'] = JSON.parse(this.shopSelected).deptCode
      }
      if (this.sectionSelected != undefined && this.sectionSelected != '') {
        params['sectionCode'] = JSON.parse(this.sectionSelected).deptCode
      }
      if (this.lineSelected != undefined && this.lineSelected != '') {
        params['lineCode'] = JSON.parse(this.lineSelected).deptCode
      }
      let options = {
        method: 'get',
        url: this.$api.factoryDev,
        params: params
      }
      var self = this
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          self.blockNum = response.data
        }
      })
    },
    getFactoryAndon () {
      let params = {
        andonStatus: 'create'
      }
      if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
        params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
      }
      if (this.shopSelected != undefined && this.shopSelected != '') {
        params['shopCode'] = JSON.parse(this.shopSelected).deptCode
      }
      if (this.sectionSelected != undefined && this.sectionSelected != '') {
        params['sectionCode'] = JSON.parse(this.sectionSelected).deptCode
      }
      if (this.lineSelected != undefined && this.lineSelected != '') {
        params['lineCode'] = JSON.parse(this.lineSelected).deptCode
      }
      let options = {
        method: 'get',
        url: this.$api.factoryAndon,
        params: params
      }
      var self = this
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          if (response.data != undefined && response.data != '') {
            this.tableData = []
            var aa = response.data
            for (let i = 0;i < aa.length;i++) {
              var array = {
                andonCode: '',
                andonProbDesc: '',
                shopName: '',
                createTime: '',
                andonRespTime: '',
                countDown: ''
              }

              array.andonCode = aa[i].andonCode
              array.andonProbDesc = aa[i].andonProbDesc
              array.shopName = aa[i].shopName
              array.createTime = aa[i].createTime
              array.andonRespTime = aa[i].andonRespTime
              var createTime = new Date(aa[i].createTime).getTime()
              var arResponseSpan = aa[i].arResponseSpan
              var date = new Date().getTime()
              var countDown = (parseInt(createTime) + (parseInt(arResponseSpan) * 1000)) - parseInt(date)
              if (countDown < 0) {
                array.countDown = ''
              } else {
                array.countDown = countDown
              }
              this.tableData.push(array)
            }
          } else {
            this.tableData = []
          }
        }
      })
    },
    getFactoryWaitAndon () {
      let params = {
        andonStatus: 'wait_complete'
      }
      if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
        params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
      }
      if (this.shopSelected != undefined && this.shopSelected != '') {
        params['shopCode'] = JSON.parse(this.shopSelected).deptCode
      }
      if (this.sectionSelected != undefined && this.sectionSelected != '') {
        params['sectionCode'] = JSON.parse(this.sectionSelected).deptCode
      }
      if (this.lineSelected != undefined && this.lineSelected != '') {
        params['lineCode'] = JSON.parse(this.lineSelected).deptCode
      }
      let options = {
        method: 'get',
        url: this.$api.factoryAndon,
        params: params
      }
      var self = this
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          if (response.data != undefined && response.data != '') {
            this.tableWaitData = []
            var aa = response.data
            for (let i = 0;i < aa.length;i++) {
              var array = {
                andonCode: '',
                andonProbDesc: '',
                shopName: '',
                createTime: '',
                andonRespTime: '',
                countDown: ''
              }
              array.andonCode = aa[i].andonCode
              array.andonProbDesc = aa[i].andonProbDesc
              array.shopName = aa[i].shopName
              array.createTime = aa[i].createTime
              array.andonRespTime = aa[i].andonRespTime
              //开始维修时间为空就用（接单时间+到达现场时效）-当前时间
              var date = new Date().getTime()
              if (aa[i].moRepairStart == undefined || aa[i].moRepairStart == '') {
                var andonRespTime = new Date(aa[i].andonRespTime).getTime()
                var arArriveSpan = new Date(aa[i].arArriveSpan).getTime()
                var countDown = (parseInt(andonRespTime) + parseInt(arArriveSpan * 1000)) - parseInt(date)
                if (countDown < 0) {
                  array.countDown = ''
                } else {
                  array.countDown = countDown
                }
              }
              //开始维修时间不为空（开始维修时间+安灯处理时效）-当前时间
              else {
                var moRepairStart = new Date(aa[i].moRepairStart).getTime()
                var arSolveSpan = new Date(aa[i].arSolveSpan).getTime()
                var countDown = (parseInt(moRepairStart) + parseInt(arSolveSpan * 1000)) - parseInt(date)
                array.countDown = countDown
                if (countDown < 0) {
                  array.countDown = ''
                } else {
                  array.countDown = countDown
                }
              }
              this.tableWaitData.push(array)
            }
          } else {
            this.tableWaitData = []
          }
        }
      })
    },
    fullscreens () {
      console.log(123)
      if (this.fullscreen == '') {
        this.fullscreen = 'fullscreen',
          this.full = false,
          this.isshow = false

        let docElm = document.documentElement
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen()
        } else if (docElm.msRequestFullscreen) {
          docElm.msRequestFullscreen()
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen()
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen()
        }
      }
    },
    fullscreens2 () {
      if (this.fullscreen != '') {
        this.fullscreen = ''
        this.full = true,
          this.isshow = true
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        }
      }
    },
    onTimeChange (e) {
      let { days, hours, minutes, seconds } = e
      // 时间换成成毫秒
      let totalMilliseconds = (days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60 + seconds) * 1000
      let percentage = totalMilliseconds / (this.time * 1000) * 100
      this.percentage = percentage
    },
    textStycut (index, item) {
      this.inde = index
      this.shopItem = item
      this.$nextTick(() => {
        this.getFactoryRepair()
        this.getFactoryDev()
        this.getFactoryAndon()
      })
    },
    beforeDestroy () {
      if (this.timer) {
        clearInterval(this.timer)//在vue实例销毁钱，清除我们的定时器
      }
    },
    //跨行跨列
    // objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
    //   let rowspan = this.tableData.length
    //   if (columnIndex === 0) {
    //     if (rowIndex % rowspan === 0) {
    //       return {
    //         rowspan: rowspan,
    //         colspan: 1
    //       }
    //     } else {
    //       return {
    //         rowspan: 0,
    //         colspan: 0
    //       }
    //     }
    //   }
    // },
    //表格斑马线
    tableRowClassName ({ rowIndex }) {
      if (rowIndex % 2 === 0) {
        return 'warning-row'
      } else if (rowIndex % 2 === 1) {
        return 'success-row'
      }
      return ''
    },
    //环形图
    echarts (data) {
      var chartDom = document.getElementById('echarInfo')
      var myChart = echarts.init(chartDom)
      var option
      option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          icon: 'rect',
          itemWidth: 15,  // 设置宽度
          itemHeight: 15, // 设置高度
          orient: 'vertical',
          bottom: '5%',  //图例距下的距离
          itemGap: 20,
          textStyle: { //图例文字的样式
            color: '#fff'
          },
          formatter: function (params) {
            var legendIndex = 0
            data.forEach(function (v, i) {
              console.log('params', params)
              if (v.name == params) {
                legendIndex = i
              }
            })
            return params + ' ' + data[legendIndex].value
          }
        },
        series: [
          {
            name: '车间状态',
            type: 'pie',
            radius: ['30%', '50%'],
            center: ['50%', '40%'], //图的位置，距离左跟上的位置
            avoidLabelOverlap: false,
            calculable: true,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false,
                fontSize: '20'
                // fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },

            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList = [
                    {
                      c1: ' #f3950d',  //异常
                      c2: '#fbc002'
                    },
                    {
                      c1: ' #0582ff',  //正常
                      c2: '#25c8ff'
                    }]
                  return new echarts.graphic.LinearGradient(1, 0, 0, 0, [{ //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上

                    offset: 0,
                    color: colorList[params.dataIndex].c1
                  }, {
                    offset: 1,
                    color: colorList[params.dataIndex].c2
                  }])
                }
              }
            },
            data: data
          }
        ]
      }

      option && myChart.setOption(option)
    },
    //柱状图
    ecahrbar (data) {
      var chartDom = document.getElementById('ecahrbar')
      var myChart = echarts.init(chartDom)
      var option

      option = {
        legend: {
          x: 'center',
          y: ' center',
          icon: 'rect',
          itemWidth: 15,  // 设置宽度
          itemHeight: 15, // 设置高度
          padding: [0, 10, 0, 0],
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {},
        dataset: {
          source: /*[
            ['product', '正常', '异常'],
            ['装配车间', 43.3, 85.8, 93.7],
            ['固定节实轴车间', 83.1, 73.4, 55.1],
            ['移动节车间', 86.4, 65.2, 82.5],
            ['锻工车间', 72.4, 53.9, 39.1]
          ]*/data
        },
        grid: {
          top: 30,
          bottom: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'category',

          //设置坐标轴字体颜色和宽度
          axisLabel: {//这是y轴文字颜色
            color: '#fff',
            interval: 0,
            textStyle: {
              //   fontSize: 10,
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        yAxis: {
          //设置坐标轴字体颜色和宽度
          axisLabel: {//这是y轴文字颜色
            color: '#fff',
            formatter: '{value} 台'
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          {
            type: 'bar',
            barWidth: 10,//柱图宽度
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0, 0, 0, 1, [
                  { offset: 0, color: '#36fb2d' },                   //柱图渐变色
                  { offset: 0.5, color: '#2fe227' },                 //柱图渐变色
                  { offset: 1, color: '#2bd324' }          //柱图渐变色
                ]
                )
              }
            }
          },
          {
            type: 'bar',
            barWidth: 10,//柱图宽度
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0, 0, 0, 1, [
                  { offset: 0, color: '#fbc002' },                   //柱图渐变色
                  { offset: 0.5, color: '#f8ab07' },                 //柱图渐变色
                  { offset: 1, color: '#f3950d' }                  //柱图渐变色
                ]
                )
              }
            }
          }
        ]
      }

      option && myChart.setOption(option)
    }
  },
  filters: {
    //设置一个函数来进行过滤
    formaDate: function (value) {
      //创建一个时间日期对象
      var date = new Date()
      var year = date.getFullYear()      //存储年
      var month = padaDate(date.getMonth() + 1)    //存储月份
      var day = padaDate(date.getDate())         //存储日期
      var hours = padaDate(date.getHours())      //存储时
      var minutes = padaDate(date.getMinutes())  //存储分
      var seconds = padaDate(date.getSeconds())  //存储秒
      //返回格式化后的日期
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds + ''
    }
  }
}
</script>

<style lang="scss" scoped>
.el-container .el-container .el-main .pageBox > div {
    height: max-content;
}
.background {
    zoom: 1;
    width: 100%;
    height: max-content;
    text-align: left;
    background-size: cover;
    -o-background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center 0;
    -webkit-background-size: cover;
}

.topInfo {
    height: 9vh;
    display: flex;
    box-shadow: 0 1px 15px #000;
    border-bottom: 0.4vh #ffbf44 solid;
}

.Logo {
    width: 8vw;
    height: 7.5vh;
    margin: 0.5vh 0 0 1vw;
}

.topTit {
    width: 100%;
    height: 100%;
    color: #fff;
    margin-left: 2vw;
    font-size: 1.4vw;
}

.page {
    display: flex;
    align-items: center;
    justify-content: center;
}

.timeimg {
    width: 1vw;
    height: 2vh;
}

.time {
    width: 100%;
    height: 100%;
    color: #fff;
    display: flex;
    letter-spacing: 1px;
    align-items: center;
}

.mouse {
    cursor: pointer;
}

.long {
    height: 4vh;
    margin: 1vw 2vw 1vw 2vw;
    border-right: 1px solid #fff;
}

.textSty {
    display: flex;
    color: #d9ca53;
    font-size: 1.1vw;
    text-align: center;
    align-items: center;
    background-size: 100% 100%;
    justify-content: center;
    padding: 1vw 2vw 1vw 2vw;
    margin: 0.9vw 0.5vw 1vw 0.5vw;
    // border: 0.5px #ccc solid;
    // background-color: #0b3c737a;
}

.textStyList {
    display: flex;
    color: #d9ca53;
    font-size: 1.1vw;
    text-align: center;
    align-items: center;
    background-size: 100% 100%;
    justify-content: center;
    padding: 1vw 1vw 1vw 1vw;
    // border: 0.5px #ccc solid;
    margin: 1vw 0.5vw 1vw 0.5vw;
    // background-color: #0b3c737a;
    background-image: url('../../../assets/icon/Titbgimg.png');
}

.textSty2 {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1vw 2vw 1vw 2vw;
    margin: 0.9vw 0.5vw 1vw 0.5vw;
}

.textSty3 {
    display: flex;
    margin-left: 1.5vw;
    align-items: center;
}

.textSty4 {
    display: flex;
    color: #35ebcf;
    align-items: center;
}

.textSty5 {
    font-size: 4px;
    padding: 2px;
    margin: 0.2vw;
}

.moduleInfo {
    margin-left: 1vw;
    margin-bottom: 1vw;
    border: 0.1px #cccccc78 solid;
}

.moduleBgColor {
    background-color: #0b3c737a;
}

.repairbill {
    width: 1.1vw;
    height: 1.6vh;
    margin: 1vw 0.7vw 0.7vw 1vw;
}

.repairbill2 {
    height: 2vh;
    width: 0.9vw;
    margin: 0 1vw 0 1vw;
}

.repairbill3 {
    height: 2vh;
    width: 1.3vw;
    margin: 0 1vw 0 1vw;
}

.repairbill4 {
    height: 2vh;
    width: 1.1vw;
    margin: 0 1vw 0 1vw;
}

.maintain {
    width: 1vw;
    height: 1vw;

    margin: 1vw 0.5vw 1vw 0.5vw;
}

.echar {
    height: 40vh;
    margin-top: 1vw;
    margin-left: 2vw;
    background-color: #05337e;
    border: 0.1px #cccccc78 solid;
}

#echarInfo {
    width: 100%;
    height: 100%;
}

.section {
    height: 40vh;
    color: #fff;
    overflow: auto;
    margin-top: 1vw;
    margin-left: 1vw;
    border: 0.1px #cccccc78 solid;
}

.divBor {
    border-radius: 3px;
    // border: 1px #e5e5e5ad solid;
}

.bgColor1 {
    background-color: #f35358;
}

.bgColor2 {
    background-color: #d6cc56;
}

.bgColor3 {
    background-color: #67de37;
}

.equiinfo ::v-deep th {
    text-align: center;
    border-right: none;
    border-bottom: 0px !important; /*删除表头下横线*/
}

.equiinfo ::v-deep .el-table,
.el-table__expanded-cell {
    background-color: transparent !important;
}

/* //透明化行、单元格,删除表头下横线 */
.equiinfo ::v-deep tr,
.equiinfo ::v-deep td {
    text-align: center;
    background: #1439391c !important;
    color: #fff;
    border-right: none;
    // border-bottom: 1px dashed #46d4ff; /*下横线*/
}

/* //hover时样式 */
.equiinfo ::v-deep .el-table tbody tr:hover > td {
    background-color: #367f7f78 !important;
}

/* // 表格内容(有用) */
.equiinfo ::v-deep .el-table__row {
    background: #1439391c !important;
    color: #46d4ff;
}

.el-table--border::after ::v-deep,
.el-table--group::after ::v-deep,
.el-table::before ::v-deep {
    background-color: transparent;
}

.warning-row ::v-deep {
    background: #0c4886 !important;
}

.success-row ::v-deep {
    background: #0b3d70 !important;
}

// .countdown {
//     width: 3.5vw;
//     height: 1.3vh;
//     margin-left: 1vw;
//     border-radius: 15px;
//     background-color: red;
// }
.dutyNum {
    font-size: 89%;
    height: 32vh;
    background-color: #0b3c737a;
    border: 0.1px #cccccc78 solid;
}

.Sty1 {
    // margin: 1vw 2vw 0.5vw 2vw;
}

#ecahrbar {
    width: 100%;
    height: 100%;
}

.stymar {
    margin-top: 1.5vw;
}

.manInfo {
    background-color: #0b3c737a;
    border: 0.1px #cccccc78 solid;
}

.el-progress--circle ::v-deep .el-progress__text,
.el-progress--dashboard ::v-deep .el-progress__text {
    color: #fff !important;
}

.fullscreen {
    top: 0;
    left: 0;
    z-index: 9999;
    position: absolute;
}

// 滚动条样式
::-webkit-scrollbar {
    width: 4px !important;
    /*height: 4px;*/
}

::-webkit-scrollbar-thumb {
    border-radius: 10px !important;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.068) !important;
    background: rgba(0, 0, 0, 0.068) !important;
}

::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.068) !important;
    border-radius: 0 !important;
    background: rgba(0, 0, 0, 0.068) !important;
}

// 选择框样式
.el-select ::v-deep .el-input__inner {
    background-color: #0c4686 !important;
    border: 1px #2c2ca28a solid !important;
    color: #fff !important;
}
</style>
